import React, { useEffect } from 'react';
import ReactGA from 'react-ga';
import { useParams } from 'react-router-dom';

import Layout from '../../containers/Layout';
import ImageTitle, { Icons } from '../../components/ImageTitle';
import Button from '../../components/Button';
import { Options, Content } from './styles';
import { getSnowdenURL } from '../../utils/snowden.util';
import { useDefaultGtm } from '../../hooks/gtm/default/useDefaultGtm';

const MethodError: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { sendDataToGtm } = useDefaultGtm();

  useEffect(() => {
    sendDataToGtm({
      type: 'checkout',
      name: '/pagamento/infos-pagamento-error',
    });
    // eslint-disable-next-line
  }, []);

  return (
    <Layout dark>
      <ImageTitle
        data-cy='payment-failed'
        icon={Icons.alertOrder}
        text="Não conseguimos processar o seu pagamento, pois a bandeira do cartão informado está diferente do pedido."
        primary
      />
      <Content>
        Caso deseje mudar de cartão, por favor entre em contato com o vendedor,
        ou tente novamente com um cartão da mesma bandeira.
      </Content>
      <Options>
        <Button
          data-cy='try-again-button'
          theme="MINIMAL"
          onClick={() => {
            ReactGA.outboundLink({ label: 'Método inválido' }, () => {
              window.location.href = getSnowdenURL(id);
            });
          }}
        >
          Tentar novamente
        </Button>
      </Options>
    </Layout>
  );
};

export default MethodError;
